import { inject, Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { UserPerson } from '@shared/interfaces/user.interface';
import { Employee } from '@shared/models/employee.model';
import { AppRole } from '@shared/auth/enums/app-role.enum';

@Injectable({ providedIn: 'root' })
export class AuthContextService {
  private readonly storage = inject(StorageService);

  getUser(): UserPerson | null {
    return this.storage.UserPerson;
  }

  getSelectedEmployee(): Employee | null {
    return this.storage.Employee;
  }

  getCurrentRole(): AppRole | null {
    const role = this.getSelectedEmployee()?.role;
    const mappedRole = role as unknown as AppRole;
    return Object.values(AppRole).includes(mappedRole) ? mappedRole : null;
  }

  isLoggedIn(): boolean {
    return this.storage.isLogged;
  }

  hasSelectedEmployee(): boolean {
    return !!this.getSelectedEmployee()?.id;
  }
}
